import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const townApi = createApi({
  reducerPath: "Town",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 300,
  endpoints(builder) {
    return {
      deleteTown: builder.mutation({
        query: (input) => {
          return {
            url: `/api/town/storageRoles/${input.id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
          };
        },
        invalidatesTags: ["Town"],
      }),
      addTown: builder.mutation({
        query: (input) => {
          return {
            url: `/api/town/storageRoles`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
            body: {
              ...input,
            },
          };
        },
        invalidatesTags: ["Town"],
      }),
      updateTown: builder.mutation({
        query: (input) => {
          return {
            url: `/api/town/storageRoles/${input.id}`,
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
            body: {
              ...input,
            },
          };
        },
        invalidatesTags: ["Town"],
      }),
      fetchTown: builder.query({
        query: (token) => {
          return {
            url: "/api/town/storageRoles",
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        },
        providesTags: ["Town"],
      }),
      fetchTownWithyCity: builder.query({
        query: (input) => {
          return {
            url: `/api/town/storageRoles/townWithCity/${input.address.city}`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${input.token}`,
            },
          };
        },
        providesTags: ["Town"],
      }),
    };
  },
});

export const {
  useFetchTownQuery,
  useFetchTownWithyCityQuery,
  useAddTownMutation,
  useUpdateTownMutation,
  useDeleteTownMutation,
} = townApi;
export { townApi };
